import Alpine from 'alpinejs'

/** @type {typeof import('vanilla-tilt').default} */
let Tilt = null

export default (function () {
  Alpine.data('tilt', function(immediate = false, conf = {}) {
    /** @type {import('vanilla-tilt').default | null} */
    let instance = null
    return {
      init() {
        if (immediate) this.load()
      },
      async load() {
        if (!Tilt) {
          Tilt = await import(/* webpackMode: "lazy-once" */'vanilla-tilt')
            .then(mod => mod.default)
            .catch((e) => console.warn(e))
        }
        instance = new Tilt(this.$el, {
          reset: false,
          max: 25,
          speed: 400,
          ...conf,
        })
      },
      destroy() {
        if (instance) instance.destroy()
      },
    }
  })
})()